import React, { useState } from "react";
import styled from "styled-components";
import Box from "./Box";

interface Props {
  opacity?: number;
  onPress?: () => void;
  style?: React.CSSProperties;
}

const TouchableOpacity: React.FC<Props> = (props) => {
  const { children, style = {}, onPress, opacity = 0.4 } = props;
  const [touched, setTouched] = useState(false);
  return (
    <StyledBox
      onTouchStart={() => setTouched(true)}
      onTouchEnd={() => setTouched(false)}
      onTouchCancel={() => setTouched(false)}
      onClick={onPress}
      style={style}
      opacity={touched ? opacity : 1}
    >
      {children}
    </StyledBox>
  );
};

const StyledBox = styled(Box)<{ opacity: number }>`
  opacity: ${(props) => props.opacity};
`;

export default TouchableOpacity;
